export const VALIDATION_MESSAGES = {
  LOCKDOWN_APPLICATION_DUE_TO_FAILED_VERIFICATION:
    'Verification of your ID or income was unsuccessful. Please contact the property manager for information on how to proceed.',
};
